// styled components
import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Table, Empty, Radio, Form, Input, Popover, Modal, Button, notification } from "antd";
const { TextArea } = Input;
// models
import { contextoDeLaPostulacion, verificarPropuesta } from "../../../../../utils/verificarPropuesta";
import { EtapaVerificacion } from "../../../../../utils/verificacionAdministrativa";
import { ModalEtapaVerificacion } from "../../../../../components/Administrador/ModalEtapaVerificacion/ModalEtapaVerificacion";
import { PostulacionModel } from "../../../../../models/PostulacionesModel/postulacion.model";
// icons
import { EyeOutlined, DownloadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { ModalVisualizarDocumentos } from "../../../../../components/Generales/ModalVisualizarDocumentos";
import { useGestionarPostulaciones } from "../../../../../hooks/useGestionarPostulaciones";
import { TemplateContext } from "../../../../../utils/template_context";
import { DownloadFile } from "../../../../../utils/DownloadFile";
import apiParticipantes from "../../../../../api/Participantes/api-participantes";
import getStorageUser from "../../../../../middlewares/GetStorageUser"
import { ParticipanteCard } from "../../../../../components/Shared/ParticipanteCard";
import apiDocumentos from "../../../../../api/Documentos/api-documentos";
import {
  DatosPostulacionPDF,
  construirCarta,
  construirDeclaracionGC,
  construirDeclaracionResidencia,
  construirRelacion,
  descargarBlob,
  obtenerFirmaB64,
} from '../../../../../utils/documentosPostulacionPDF';
import {
  esCartaDeConformacion,
  esDeclaracionDeGrupo,
  esDeclaracionDeResidencia,
  esDeclaracionUnificada,
  esRelacionDeParticipantes,
} from '../../../../../utils/documentosGrupoConformado';

// models
interface IProps {
  postulacion: any;
  setAllPostulaciones: any;
  allpostulaciones: any;
  descargarArchivo: any;
  isBeps?: boolean;
  lineasConvocatoria: any;
  setCountSubsanable: any;
  countSubsanable: any;
  setIdPostulacion?: any;
  idPostulacion?: any;
  setObservaciones?: any;
  observaciones?: any;
  registerExportFn?: (fn: () => Promise<{ nombre: string, blob: Blob }[]>) => void;
}


export const InformacionPostulacion: React.FC<IProps> = (props: IProps) => {

  const { obtenerLineasConvocatorias } =
    useGestionarPostulaciones();
  // state
  const [documento, setDocumento] = useState<string>("");
  const context = useContext(TemplateContext);
  const [user, setUser] = useState<any>({});
  const [isExporting, setIsExporting] = useState<boolean>(false);

  const fetchB64 = async (url: string): Promise<string> => {
    if (!url) return '';
    try {
      const data = await apiDocumentos.consultarArchivo(url);
      if (data?.data) return new Promise<string>((resolve) => { const r = new FileReader(); r.readAsDataURL(data.data); r.onloadend = () => resolve(r.result as string); r.onerror = () => resolve(''); });
    } catch { /* */ }
    return '';
  };

  useEffect(() => {
    if (props.registerExportFn) {
      props.registerExportFn(async () => {
        setIsExporting(true);
        const docs = props.postulacion?.documentos_administrativos || [];
        const result: { nombre: string, blob: Blob }[] = [];

        for (const doc of docs) {
          if (esDeclaracionDeResidencia(doc) && !(doc.participantes?.length > 0)) {
            const firmaB64 = await fetchB64(doc.firma_declaracion);
            result.push({ nombre: `${props.postulacion.radicado}_${doc.descripcion}.pdf`, blob: _buildDeclaracionResidencia(doc, firmaB64) });
          } else if (doc.descripcion === "Relación de participantes de la propuesta" && doc.participantes?.length > 0) {
            const firmasMap: {[k: number]: string} = {};
            await Promise.all(doc.participantes.map(async (p: any, i: number) => { if (p.firma) firmasMap[i] = await fetchB64(p.firma); }));
            result.push({ nombre: `${props.postulacion.radicado}_${doc.descripcion}.pdf`, blob: _buildRelacion(doc, firmasMap, firmasMap[0] || '') });
          } else if (esCartaDeConformacion(doc) && doc.participantes?.length > 0) {
            const firmasMap: {[k: number]: string} = {};
            await Promise.all(doc.participantes.map(async (p: any, i: number) => { if (p.firma) firmasMap[i] = await fetchB64(p.firma); }));
            result.push({ nombre: `${props.postulacion.radicado}_${doc.descripcion}.pdf`, blob: _buildCarta(doc, firmasMap, firmasMap[0] || '') });
          } else if (esDeclaracionDeGrupo(doc)) {
            const firmasMap: {[k: number]: string} = {};
            await Promise.all(doc.participantes.map(async (p: any, i: number) => { if (p.firma) firmasMap[i] = await fetchB64(p.firma); }));
            result.push({ nombre: `${props.postulacion.radicado}_${doc.descripcion}_GC.pdf`, blob: _buildDeclaracionGC(doc, firmasMap, firmasMap[0] || '') });
          }
        }

        setIsExporting(false);
        return result;
      });
    }
  }, [props.registerExportFn, props.postulacion]);

  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  const validateObservaciones = async () => {
    const postulacion = await apiParticipantes.consultarPostulacion(props?.postulacion?.id_postulacion);
    props.setCountSubsanable(
      props.postulacion.estado === 'Subsanar' ? 1 : 0
    )
    props.setObservaciones(postulacion?.data?.observaciones || '')
  }

  useEffect(() => {
    getUser();
    validateObservaciones()
  }, [props.postulacion])

  // disabled subsanar
  useEffect(() => {
    obtenerLineasConvocatorias();
  }, []);

  const [openModalDeclaracion, setOpenModalDeclaracion] = useState(false);
  const [datosDeclaracion, setDatosDeclaracion] = useState<any>({});

  const [openModalRelacion, setOpenModalRelacion] = useState(false);
  const [datosRelacion, setDatosRelacion] = useState<any>({});
  const [firmaParticipante, setFirmaParticipante] = useState<string>("");
  const [firmasParticipantes, setFirmasParticipantes] = useState<{ [key: number]: string }>({});

  const [openModalCartaConformacion, setOpenModalCartaConformacion] = useState(false);
  const [datosCartaConformacion, setDatosCartaConformacion] = useState<any>({});

  const [openModalDeclaracionGC, setOpenModalDeclaracionGC] = useState(false);
  const [datosDeclaracionGC, setDatosDeclaracionGC] = useState<any>({});


  const [fileName, setFileName] = useState<any>("");

  const [openModal, setOpenModal] = useState(false);
  const [openModalEscritoVideo, setOpenModalEscritoVideo] = useState(false);
  const [datosEscritoVideo, setDatosEscritoVideo] = useState<any>({});

  const getSignature = async (firma) => {
    if (!firma) return;
    try {
      const data = await apiDocumentos.consultarArchivo(firma);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          setFileName(base64String);
        }
      }
    } catch (error) {
      console.error("Error al consultar firma:", error);
    }
  };

  const getSignatureParticipante = async (firma: string, index: number) => {
    try {
      const data = await apiDocumentos.consultarArchivo(firma);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          if (index === 0) {
            setFirmaParticipante(base64String as string);
          }
          // Guardar la firma en el objeto de firmas
          setFirmasParticipantes(prev => ({
            ...prev,
            [index]: base64String as string
          }));
        }
      }
    } catch (error) {
      console.error('Error al obtener la firma del participante:', error);
      if (index === 0) {
        setFirmaParticipante("");
      }
      setFirmasParticipantes(prev => ({
        ...prev,
        [index]: ""
      }));
    }
  };

  // Los PDF de documentos administrativos se arman en utils/documentosPostulacionPDF, compartidos
  // con la vista del participante. Aquí solo se aportan los datos propios de esta vista.
  const _datosPDF = (): DatosPostulacionPDF => ({
    lineaConvocatoria: props.postulacion.linea_convocatoria,
    numeroDocumento: props.postulacion.numero_documento_participante,
  });

  // Desde administración no hay sesión del declarante: se usa el representante de la postulación y
  // el tipo de documento guardado en la declaración.
  const _declarante = (dd: any) => ({
    nombre: props.postulacion.nombre_representante,
    tipoIdentificacion: dd?.tipo_documento,
  });

  const _fetchFirmaB64 = obtenerFirmaB64;
  const _downloadBlob = descargarBlob;
  const _buildDeclaracionResidencia = (dd: any, firmaB64: string): Blob =>
    construirDeclaracionResidencia(dd, firmaB64, _datosPDF(), _declarante(dd));
  const _buildRelacion = (dd: any, firmasMap: { [k: number]: string }, firmaRepB64: string): Blob =>
    construirRelacion(dd, firmasMap, firmaRepB64, _datosPDF());
  const _buildCarta = (dd: any, firmasMap: { [k: number]: string }, firmaRepB64: string): Blob =>
    construirCarta(dd, firmasMap, firmaRepB64, _datosPDF());
  const _buildDeclaracionGC = (dd: any, firmasMap: { [k: number]: string }, firmaRepB64: string): Blob =>
    construirDeclaracionGC(dd, firmasMap, firmaRepB64, _datosPDF());

  const imprimirPdf = (nombreArchivo: string, tipo: string): void => {
    let blob: Blob;
    if (tipo === 'declaracion') blob = _buildDeclaracionResidencia(datosDeclaracion, fileName);
    else if (tipo === 'relacion') blob = _buildRelacion(datosRelacion, firmasParticipantes, firmaParticipante);
    else if (tipo === 'carta') blob = _buildCarta(datosCartaConformacion, firmasParticipantes, firmaParticipante);
    else if (tipo === 'declaracion_gc') blob = _buildDeclaracionGC(datosDeclaracionGC, firmasParticipantes, firmaParticipante);
    else return;
    _downloadBlob(blob, nombreArchivo);
  };

  const descargarDocumentoOnlineInvisible = async (documentoCompleto: any) => {
    setIsExporting(true);
    try {
      if (
        esDeclaracionDeResidencia(documentoCompleto) &&
        !(documentoCompleto?.participantes?.length > 0)
      ) {
        const firmaB64 = await _fetchFirmaB64(documentoCompleto.firma_declaracion);
        _downloadBlob(_buildDeclaracionResidencia(documentoCompleto, firmaB64), `${props.postulacion.radicado || ''}_${documentoCompleto.descripcion}`);
      } else if (documentoCompleto?.descripcion === "Relación de participantes de la propuesta" && documentoCompleto?.participantes?.length > 0) {
        const firmasMap: {[k: number]: string} = {};
        await Promise.all(documentoCompleto.participantes.map(async (p: any, i: number) => { if (p.firma) firmasMap[i] = await _fetchFirmaB64(p.firma); }));
        _downloadBlob(_buildRelacion(documentoCompleto, firmasMap, firmasMap[0] || ''), `${props.postulacion.radicado || ''}_${documentoCompleto.descripcion}`);
      } else if (
        esCartaDeConformacion(documentoCompleto) &&
        documentoCompleto?.participantes?.length > 0
      ) {
        const firmasMap: {[k: number]: string} = {};
        await Promise.all(documentoCompleto.participantes.map(async (p: any, i: number) => { if (p.firma) firmasMap[i] = await _fetchFirmaB64(p.firma); }));
        _downloadBlob(_buildCarta(documentoCompleto, firmasMap, firmasMap[0] || ''), `${props.postulacion.radicado || ''}_${documentoCompleto.descripcion}`);
      } else if (esDeclaracionDeGrupo(documentoCompleto)) {
        const firmasMap: {[k: number]: string} = {};
        await Promise.all(documentoCompleto.participantes.map(async (p: any, i: number) => { if (p.firma) firmasMap[i] = await _fetchFirmaB64(p.firma); }));
        _downloadBlob(_buildDeclaracionGC(documentoCompleto, firmasMap, firmasMap[0] || ''), `${props.postulacion.radicado || ''}_${documentoCompleto.descripcion}_GC`);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsExporting(false);
    }
  };

  const modalAnexo = (datos: any, documentoCompleto?: any) => {
    // Si el documento es "Declaración de Residencia" y tiene datos guardados, mostrar modal de declaración
    if (
      esDeclaracionDeResidencia(documentoCompleto) &&
      !(documentoCompleto?.participantes?.length > 0) &&
      (!documentoCompleto?.url_participante || documentoCompleto?.url_participante == "")
    ) {
      setDatosDeclaracion(documentoCompleto);
      setOpenModalDeclaracion(true);
      getSignature(documentoCompleto?.firma_declaracion)
    } else if (documentoCompleto?.descripcion === "Relación de participantes de la propuesta" && documentoCompleto?.participantes?.length > 0) {
      setDatosRelacion(documentoCompleto);
      setOpenModalRelacion(true);
      // Obtener las firmas de todos los participantes
      documentoCompleto.participantes.forEach((participante: any, index: number) => {
        if (participante?.firma) {
          getSignatureParticipante(participante.firma, index);
        }
      });
    } else if (
      esCartaDeConformacion(documentoCompleto) &&
      documentoCompleto?.participantes?.length > 0
    ) {
      setDatosCartaConformacion(documentoCompleto);
      setOpenModalCartaConformacion(true);
      // Obtener las firmas de todos los participantes
      documentoCompleto.participantes.forEach((participante: any, index: number) => {
        if (participante?.firma) {
          getSignatureParticipante(participante.firma, index);
        }
      });
    } else if (esDeclaracionDeGrupo(documentoCompleto)) {
      setDatosDeclaracionGC(documentoCompleto);
      setOpenModalDeclaracionGC(true);
      // Obtener las firmas de todos los participantes
      documentoCompleto.participantes.forEach((participante: any, index: number) => {
        if (participante?.firma) {
          getSignatureParticipante(participante.firma, index);
        }
      });
    } else {
      if (datos && typeof datos === 'string' && datos.trim() !== '') {
        setDocumento(datos)
        setOpenModal(true);
      }
    }
  }

  // columns table documentación técnica
  const columnasDocumentaciontecnicaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 100,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any, record: any, index: number) => (
        <Row className="width-100">
          <Col span={24}>{datos.tipo_documento || datos.descripcion}</Col>
        </Row>
      ),
    },
    {
      title: "Nombre del documento",
      width: 100,
      render: (datos: any, datos2: any, index: number) => {
        const esEscritoVideo = datos.tipo_documento === "Escrito y Video";
        const tieneContenido = datos.escrito || datos.url_video;
        const etiquetaContenido = tieneContenido ? "Diligenciado en el sistema" : "No se cargó información";
        return (
          <>
            {esEscritoVideo ? (
              <span>{etiquetaContenido}</span>
            ) : (
              <span>{datos.url_participante}</span>
            )}
          </>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Info doc
          </Col>
        </Row>
      ),
      width: 50,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        return (
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Popover
                  title="Trazabilidad del documento"
                  content={
                    <div style={{ fontSize: 'small' }}>
                      <p className="font-color-00904C">Fecha aceptado: <span style={{ fontWeight: 'bold' }}>{datos.fecha_aceptado}</span></p>
                      <p className="font-color-00904C">Aceptado por: <span style={{ fontWeight: 'bold' }}>{datos.aceptado_por}</span></p>
                      <hr />
                      <p className="font-color-DB2828">Fecha rechazado: <span style={{ fontWeight: 'bold' }}>{datos.fecha_rechazado}</span></p>
                      <p className="font-color-DB2828">Rechazado por: <span style={{ fontWeight: 'bold' }}>{datos.rechazado_por}</span></p>
                    </div>
                  }>
                  <InfoCircleOutlined />
                </Popover>
              </Col>
            </Row>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Aceptado
          </Col>
        </Row>
      ),
      width: 100,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        const isEscritoVideo = datos.tipo_documento === "Escrito y Video";
        const hasContent = datos.url_documento || datos.url_participante || (isEscritoVideo && (datos.escrito || datos.url_video));

        if (user.documento != '43188189') {
          if (hasContent) {
            return (
                <Row className="width-100">
                  <Col span={24} className="justify-content-center">
                    <Radio.Group
                      value={datos.checkaceptartecnico}
                      onChange={(e: any) =>
                        handlechangechecktecnicos(
                          e,
                          datos,
                          index,
                          props.postulacion
                        )
                      }
                    >
                      <Radio value={true}>Sí</Radio>
                      <Radio value={false}>No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
            );
          }
        }
      },
    },
    {
      title: (
        <>
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              Acciones
            </Col>
          </Row>
          <Row className="width-100">
            <Col span={12} className="justify-content-center">
              <span className="font-family-Montserrat-Regular font-size-10px font-color-707070">
                Ver
              </span>
            </Col>
            <Col span={12} className="justify-content-center">
              <span className="font-family-Montserrat-Regular font-size-10px font-color-707070">
                Descargar
              </span>
            </Col>
          </Row>
        </>
      ),
      width: 100,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        const isEscritoVideo = datos.tipo_documento === "Escrito y Video";
        const hasContent = datos.url_documento || datos.url_participante || (isEscritoVideo && (datos.escrito || datos.url_video));

        if (hasContent) {
          return (
              <Row className="width-100">
                <Col span={12} className="justify-content-center">
                  <EyeOutlined
                    onClick={() => {
                      if (isEscritoVideo) {
                        setDatosEscritoVideo(datos);
                        setOpenModalEscritoVideo(true);
                      } else {
                        setOpenModal(true);
                        setDocumento(datos.url_participante);
                      }
                    }}
                  />
                </Col>
                <Col span={12} className="justify-content-center">
                  {!isEscritoVideo && (
                    <DownloadOutlined
                      onClick={() =>
                        DownloadFile(datos.url_participante)
                      }
                    />
                  )}
                </Col>
              </Row>
          );
        }
      },
    },
  ];
  //  columns table documentación técnica
  const columnasDocumentacionadministrativaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 380,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => (
        <Row className="width-100">
          <Col span={24}>{datos.descripcion}</Col>
        </Row>
      ),
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Info doc
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Popover
                  title="Trazabilidad del documento"
                  content={
                    <div style={{ fontSize: 'small' }}>
                      <p className="font-color-6435C9">Fecha subsanado: <span style={{ fontWeight: 'bold' }}>{datos.fecha_subsanado}</span></p>
                      <p className="font-color-6435C9">Subsanado por: <span style={{ fontWeight: 'bold' }}>{datos.subsanado_por}</span></p>
                      {datos.url_anterior && (
                        <p className="font-color-6435C9">Ver anterior: {' '}
                          <span style={{ fontWeight: 'bold' }}>
                            <EyeOutlined
                              onClick={() => {
                                setOpenModal(true);
                                setDocumento(datos.url_anterior);
                              }} />
                          </span>
                        </p>)
                      }
                      <hr />
                      <p className="font-color-F28C02">Fecha subsanar: <span style={{ fontWeight: 'bold' }}>{datos.fecha_subsanar}</span></p>
                      <p className="font-color-F28C02">Actualizado por: <span style={{ fontWeight: 'bold' }}>{datos.actualizado_por}</span></p>
                      <hr />
                      <p className="font-color-00904C">Fecha aceptado: <span style={{ fontWeight: 'bold' }}>{datos.fecha_aceptado}</span></p>
                      <p className="font-color-00904C">Aceptado por: <span style={{ fontWeight: 'bold' }}>{datos.aceptado_por}</span></p>
                      <hr />
                      <p className="font-color-DB2828">Fecha rechazado: <span style={{ fontWeight: 'bold' }}>{datos.fecha_rechazado}</span></p>
                      <p className="font-color-DB2828">Rechazado por: <span style={{ fontWeight: 'bold' }}>{datos.rechazado_por}</span></p>
                    </div>
                  }>
                  <InfoCircleOutlined />
                </Popover>
              </Col>
            </Row>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Subsanar
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Radio
                  name="checksubsanable"
                  value={datos.checksubsanable}
                  checked={datos.checksubsanable}
                  onChange={(e) =>
                    handlechangecheck(e, datos, index, props.postulacion)
                  }
                />
              </Col>
            </Row>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Aceptado
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Radio
                  name="checkaceptar"
                  checked={datos.checkaceptar}
                  value={datos.checkaceptar}
                  onChange={(e) =>
                    handlechangecheck(e, datos, index, props.postulacion)
                  }
                />
              </Col>
            </Row>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Rechazado
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Radio
                  name="checkrechazado"
                  checked={datos.checkcancelar}
                  value={datos.checkcancelar}
                  onChange={(e) =>
                    handlechangecheck(e, datos, index, props.postulacion)
                  }
                />
              </Col>
            </Row>
        );
      },
    },
    {
      title: (
        <>
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              Acciones
            </Col>
          </Row>
          <Row className="width-100">
            <Col span={12} className="justify-content-center">
              Ver
            </Col>
            <Col span={12} className="justify-content-center">
              Descargar
            </Col>
          </Row>
        </>
      ),
      width: 120,
      render: (datos: any, record: any, index: number) => {
        const hasParticipantes = datos?.participantes?.length > 0;
        const esDeclaracion =
          esDeclaracionDeResidencia(datos) || esDeclaracionUnificada(datos);
        const esRelacion = esRelacionDeParticipantes(datos);
        const esCarta = esCartaDeConformacion(datos);
        const esDocumentoEspecial = (esDeclaracion || esRelacion || esCarta) && (hasParticipantes || datos?.firma_declaracion);
        const tieneDocumento = datos?.url_participante || esDocumentoEspecial;
        return (
            <div className="row">
              <div className="col-6 justify-content-center">
                {tieneDocumento && (
                  <EyeOutlined
                    onClick={() => {
                      modalAnexo(datos.url_participante, datos)
                    }}
                  />
                )}
              </div>
              <div className="col-6 justify-content-center">
                {(() => {
                  if (datos?.url_participante) {
                    return <DownloadOutlined onClick={() => DownloadFile(datos.url_participante)} />;
                  }
                  if (esDocumentoEspecial) {
                    return <DownloadOutlined onClick={() => descargarDocumentoOnlineInvisible(datos)} />;
                  }
                  return null;
                })()}
              </div>
            </div>
        );
      },
    },
  ];

  const columnasDocumentacionGeneralModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 100,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => (
        <div className="row">
          <div className="col-12">{datos.descripcion}</div>
        </div>
      ),
    },
    {
      title: "Nombre del documento",
      width: 100,
      render: (datos: any, datos2: any, index: number) => {
        const esEscritoVideo = datos.tipo_documento === "Escrito y Video";
        const tieneContenido = datos.escrito || datos.url_video;
        const etiquetaContenido = tieneContenido ? "Diligenciado en el sistema" : "No se cargó información";
        return (
          <>
            {esEscritoVideo ? (
              <span>{etiquetaContenido}</span>
            ) : (
              <span>{datos.url_participante}</span>
            )}
          </>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Info doc
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Popover
                  title="Trazabilidad del documento"
                  content={
                    <div style={{ fontSize: 'small' }}>
                      <p className="font-color-6435C9">Fecha subsanado: <span style={{ fontWeight: 'bold' }}>{datos.fecha_subsanado}</span></p>
                      <p className="font-color-6435C9">Subsanado por: <span style={{ fontWeight: 'bold' }}>{datos.subsanado_por}</span></p>
                    </div>
                  }>
                  <InfoCircleOutlined />
                </Popover>
              </Col>
            </Row>
        );
      },
    },
    {
      title: "Acciones",
      width: 120,
      render: (datos: any, record: any, index: number) => {
        const hasParticipantes = datos?.participantes?.length > 0;
        const esDeclaracion =
          esDeclaracionDeResidencia(datos) || esDeclaracionUnificada(datos);
        const esRelacion = esRelacionDeParticipantes(datos);
        const esCarta = esCartaDeConformacion(datos);
        const esDocumentoEspecial = (esDeclaracion || esRelacion || esCarta) && (hasParticipantes || datos?.firma_declaracion);
        const tieneDocumento = datos?.url_participante || esDocumentoEspecial;
        return (
            <div className="row">
              <div className="col-6 justify-content-center">
                {tieneDocumento && (
                  <EyeOutlined
                    onClick={() => {
                      modalAnexo(datos.url_participante, datos)
                    }}
                  />
                )}
              </div>
              <div className="col-6 justify-content-center">
                {(() => {
                  if (datos?.url_participante) {
                    return <DownloadOutlined onClick={() => DownloadFile(datos.url_participante)} />;
                  }
                  if (esDocumentoEspecial) {
                    return <DownloadOutlined onClick={() => descargarDocumentoOnlineInvisible(datos)} />;
                  }
                  return null;
                })()}
              </div>
            </div>
        );
      },
    },
  ];
  //   columns table enlaces
  const columnaslinksModal = [
    {
      title: "URL",
      width: 260,
      render: (datos: any, record: any, index: number) => {
        return (
          <Row className="width-100">
            <Col span={24}>
              <a href={datos.url} target="_blank">{datos.url}</a>
            </Col>
          </Row>
        );
      },
    },
  ];

  const obtenerFecha = () => {
    let fechaActual = new Date();
    let anio = fechaActual.getFullYear();
    let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2);
    let dia = ('0' + fechaActual.getDate()).slice(-2);
    let hora = ('0' + fechaActual.getHours()).slice(-2);
    let minutos = ('0' + fechaActual.getMinutes()).slice(-2);
    let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;
    return fechaYHora
  }
  /**
   * Verificación automática de esta propuesta con las reglas administrativas.
   * Deja las marcas y la observación propuestas; no guarda: el profesional revisa y usa el botón
   * de siempre para confirmar.
   */
  const [verificando, setVerificando] = useState(false);
  const [openModalEtapa, setOpenModalEtapa] = useState(false);

  const verificarConIA = async (etapa: EtapaVerificacion) => {
    setOpenModalEtapa(false);
    const documentosActuales = props.postulacion.documentos_administrativos;
    setVerificando(true);
    let resultado;
    try {
      resultado = await verificarPropuesta(
        documentosActuales,
        obtenerFecha(),
        contextoDeLaPostulacion(props.postulacion),
        { etapa, documentosTecnicos: props.postulacion.documentos_tecnicos }
      );
    } catch (error) {
      console.error("[Verificación] Error al verificar la propuesta:", error);
      notification.warning({
        message: "No se pudo completar la verificación",
        description: "Ocurrió un error al revisar los documentos. Intenta de nuevo.",
        placement: "bottomRight",
      });
      return;
    } finally {
      setVerificando(false);
    }

    if (resultado.subsanados === 0 && resultado.aceptados === 0 && resultado.rechazados === 0) {
      notification.info({
        message: "Sin cambios que proponer",
        description: resultado.respetados > 0
          ? "Los documentos que se podían revisar automáticamente ya los había decidido un profesional."
          : "No se encontró nada que se pueda verificar automáticamente en esta propuesta.",
        placement: "bottomRight",
      });
      return;
    }

    // Se refleja tanto en el objeto que muestra el modal como en el listado, igual que los checks manuales
    const todosJSON = JSON.parse(JSON.stringify(props.allpostulaciones));
    const matchIdx = todosJSON.findIndex((p: any) => p.id_postulacion === props.postulacion.id_postulacion);

    resultado.documentos.forEach((doc: any, i: number) => {
      Object.assign(documentosActuales[i], doc);
      if (matchIdx >= 0) Object.assign(todosJSON[matchIdx].documentos_administrativos[i], doc);
    });

    const tecnicosActuales = props.postulacion.documentos_tecnicos;
    if (Array.isArray(tecnicosActuales)) {
      resultado.documentosTecnicos.forEach((doc: any, i: number) => {
        Object.assign(tecnicosActuales[i], doc);
        if (matchIdx >= 0) Object.assign(todosJSON[matchIdx].documentos_tecnicos[i], doc);
      });
    }
    if (matchIdx >= 0) props.setAllPostulaciones(todosJSON);

    if (resultado.observacion) props.setObservaciones(resultado.observacion);
    props.setCountSubsanable(resultado.subsanados > 0 ? 1 : 0);

    notification.success({
      message: "Verificación automática aplicada",
      description: `${resultado.subsanados} para subsanar, ${resultado.aceptados} aceptado(s)` +
        (resultado.rechazados > 0 ? `, ${resultado.rechazados} propuesto(s) para rechazo` : "") +
        (resultado.respetados > 0 ? `, ${resultado.respetados} sin tocar por decisión previa` : "") +
        (resultado.sinLeer > 0 ? `, ${resultado.sinLeer} sin poder leer (requieren revisión manual)` : "") +
        ". Revisa y confirma antes de guardar.",
      placement: "bottomRight",
      duration: 8,
    });
  };

  //   handle
  const handlechangecheck = (
    e: any,
    datos: any,
    index: number,
    postulacion: PostulacionModel
  ) => {
    const todosJSON = JSON.parse(JSON.stringify(props.allpostulaciones));
    const matchIdx = todosJSON.findIndex((p: any) => p.id_postulacion === postulacion.id_postulacion);
    if (matchIdx < 0) return;

    const doc = props.postulacion.documentos_administrativos[index];
    const todoDoc = todosJSON[matchIdx].documentos_administrativos[index];
    const autor = `${user.nombres} ${user.apellidos}`;

    if (e.target.name === "checksubsanable") {
      doc.checksubsanable = true; doc.checkaceptar = false; doc.checkcancelar = false;
      doc.actualizado_por = autor; doc.fecha_subsanar = obtenerFecha();
      todoDoc.checksubsanable = true; todoDoc.checkaceptar = false; todoDoc.checkcancelar = false;
      todoDoc.actualizado_por = autor; todoDoc.fecha_subsanar = obtenerFecha();
      props.setCountSubsanable(1);
    }
    if (e.target.name === "checkaceptar") {
      if (doc.checksubsanable) props.setCountSubsanable(0);
      doc.checksubsanable = false; doc.checkaceptar = true; doc.checkcancelar = false;
      doc.aceptado_por = autor; doc.fecha_aceptado = obtenerFecha();
      todoDoc.checksubsanable = false; todoDoc.checkaceptar = true; todoDoc.checkcancelar = false;
      todoDoc.aceptado_por = autor; todoDoc.fecha_aceptado = obtenerFecha();
    }
    if (e.target.name === "checkrechazado") {
      if (doc.checksubsanable) props.setCountSubsanable(0);
      doc.checksubsanable = false; doc.checkaceptar = false; doc.checkcancelar = true;
      doc.rechazado_por = autor; doc.fecha_rechazado = obtenerFecha();
      todoDoc.checksubsanable = false; todoDoc.checkaceptar = false; todoDoc.checkcancelar = true;
      todoDoc.rechazado_por = autor; todoDoc.fecha_rechazado = obtenerFecha();
    }
    props.setAllPostulaciones(todosJSON);
  };
  const handlechangechecktecnicos = (
    e: any,
    datos: any,
    index: number,
    postulacion: PostulacionModel
  ) => {
    let todosJSON = JSON.parse(JSON.stringify(props.allpostulaciones));
    for (const i in todosJSON) {
      if (e.target.value) {
        props.postulacion.documentos_tecnicos[index].checkaceptartecnico =
          e.target.value;
        props.postulacion.documentos_tecnicos[index].aceptado_por = `${user.nombres} ${user.apellidos}`
        props.postulacion.documentos_tecnicos[index].fecha_aceptado = obtenerFecha()
      }
      if (!e.target.value) {
        props.postulacion.documentos_tecnicos[index].checkaceptartecnico =
          e.target.value;
        props.postulacion.documentos_tecnicos[index].rechazado_por = `${user.nombres} ${user.apellidos}`
        props.postulacion.documentos_tecnicos[index].fecha_rechazado = obtenerFecha()
      }
      if (todosJSON[i].id_postulacion === postulacion.id_postulacion) {
        props.postulacion.documentos_tecnicos[index].checkaceptartecnico =
          e.target.value;
        todosJSON[i].documentos_tecnicos[index].checkaceptartecnico =
          e.target.value;
      }
    }
    return props.setAllPostulaciones(todosJSON);
  };
  return (
    <>
      <Row
        className="width-100"
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
        }}
      >
        <Col
          span={6}
          className="font-size-12px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          {props.isBeps ? "Nombre Participante" : "Nombre representante"}
        </Col>
        {props.isBeps && (
          <Col
            className="font-size-12px font-family-Montserrat-Regular"
            span={18}
          >
            {props.postulacion.nombre_participante}
          </Col>
        )}
        {
          <Col
            className="font-size-12px font-family-Montserrat-Regular"
            span={18}
          >
            {props.postulacion.nombre_representante}
          </Col>
        }

        {props.isBeps ? null : (
          <>
            <Col
              span={6}
              className="font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Tipo de participante
            </Col>
            <Col
              className="font-size-12px font-family-Montserrat-Regular"
              span={18}
              style={{ background: "#F0F6FB" }}
            >
              {({"1": "Persona Natural", "2": "Persona Juridica", "3": "Grupo Conformado"} as Record<string,string>)[props.postulacion.tipo_participante] ?? null}
            </Col>
            <Col
              span={6}
              className="font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Línea
            </Col>
            <Col
              className="font-size-12px font-family-Montserrat-Regular"
              span={18}
            >
              {props.postulacion.linea_convocatoria}
            </Col>
            <Col
              span={6}
              className="font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Categorías
            </Col>
            <Col
              className="font-size-12px font-family-Montserrat-Regular"
              span={18}
              style={{ background: "#F0F6FB" }}
            >
              {props.postulacion.categoria_linea_convocatoria}
            </Col>
          </>
        )}
        {props.postulacion.documentos_tecnicos !== null &&
          props.postulacion.documentos_tecnicos.length > 0 ? (
          <Col
            span={24}
            className="font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Documentos Técnicos
            </span>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentaciontecnicaModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_tecnicos}
            />
          </Col>
        ) : null}
        {props.postulacion.documentos_administrativos !== null &&
          props.postulacion.documentos_administrativos.length > 0 &&
          user.documento != '43188189' ? (
          <Col
            span={24}
            className="font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <ModalEtapaVerificacion
              visible={openModalEtapa}
              onCancel={() => setOpenModalEtapa(false)}
              onConfirmar={verificarConIA}
              detalle={<p>Se revisarán los documentos administrativos de esta propuesta.</p>}
            />

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span className="font-family-Montserrat-SemiBold">
                Documentos administrativos
              </span>
              <Button
                className="button-azul-radius"
                onClick={() => setOpenModalEtapa(true)}
                loading={verificando}
                disabled={verificando}
              >
                Verificar con IA
              </Button>
            </div>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentacionadministrativaModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_administrativos}
            />
          </Col>
        ) : null}
        {props.postulacion.documentos_generales !== null &&
          props.postulacion.documentos_generales.length > 0 ? (
          <Col
            span={24}
            className="font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Subsanaciones del Ministerio
            </span>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentacionGeneralModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_generales}
            />
          </Col>
        ) : null}
        {
          user.documento != '43188189' ?
            <Col
              span={24}
              className="font-family-Montserrat-Regular font-size-13px"
              style={{ paddingTop: "16px", paddingBottom: "1%" }}
            >
              <Form
                name="basic"
                layout="vertical"
                initialValues={{ remember: true }}
                autoComplete="off"
              >
                <Input.TextArea value={props?.observaciones} rows={15} maxLength={2000} required onChange={(e) => props.setObservaciones(e.target.value)} placeholder="Ingresa las observaciones" />
              </Form>
            </Col>
            :
            <span></span>
        }
        {props.postulacion.links !== null ? (
          <Col
            span={24}
            className="font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Enlaces del proyecto
            </span>
            <Table
              pagination={false}
              style={{ paddingTop: "16px" }}
              columns={columnaslinksModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.links}
            />
          </Col>
        ) : null}
      </Row>
      {openModal &&
        <ModalVisualizarDocumentos
          visualizar={openModal}
          setVisualizar={setOpenModal}
          state={{ documento }}
        />
      }
      <Modal
        title={
          <div className="font-family-Montserrat-Bold font-size-22px color-0050A0 d-flex align-items-center">
            <EyeOutlined style={{ marginRight: '12px', fontSize: '26px' }} />
            Visualizar Escrito y Video
          </div>
        }
        visible={openModalEscritoVideo}
        onCancel={() => setOpenModalEscritoVideo(false)}
        width={900}
        centered
        footer={[
          <Button
            key="close"
            onClick={() => setOpenModalEscritoVideo(false)}
            className="button-blanco-radius"
          >
            Cerrar
          </Button>
        ]}
      >
        <div className="p-3">
          <div className="mb-4">
            <span className="font-family-Montserrat-SemiBold font-size-16px mb-2 d-block color-707070">
              Escrito o Narración de la Propuesta:
            </span>
            <TextArea
              rows={12}
              value={datosEscritoVideo?.escrito}
              disabled
              className="mt-1 font-family-Montserrat-Regular"
              style={{ borderRadius: '8px', padding: '12px', border: '1px solid #d9d9d9', color: 'rgba(0, 0, 0, 0.85)', backgroundColor: '#f5f5f5' }}
            />
          </div>
          <div className="mt-5">
            <span className="font-family-Montserrat-SemiBold font-size-16px mb-2 d-block color-707070">
              URL del video de soporte:
            </span>
            <div className="mt-1 p-3" style={{ border: '1px solid #d9d9d9', borderRadius: '8px', backgroundColor: '#f5f5f5' }}>
              <a
                href={datosEscritoVideo?.url_video}
                target="_blank"
                rel="noopener noreferrer"
                className="font-family-Montserrat-Regular"
                style={{ color: '#0050A0', textDecoration: 'underline' }}
              >
                {datosEscritoVideo?.url_video}
              </a>
            </div>
          </div>
        </div>
      </Modal>
      {openModalDeclaracion && (
        <Modal
          style={{ top: 20, zIndex: isExporting ? -999 : 3 }}
          wrapProps={{ style: isExporting ? { position: 'fixed', left: '-9999px' } : undefined }}
          mask={!isExporting}
          visible={openModalDeclaracion}
          closable={true}
          footer={[
            <Button
              key="download"
              onClick={() => imprimirPdf(`Declaracion_Residencia_${props.postulacion.radicado || ''}`, 'declaracion')}
              className="button-blanco-radius"
            >
              Descargar PDF
            </Button>,
            <Button
              key="close"
              onClick={() => setOpenModalDeclaracion(false)}
              className="button-blanco-radius"
            >
              Cerrar
            </Button>
          ]}
          onCancel={() => setOpenModalDeclaracion(false)}
          width={800}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom_declaracion" className="document-page">
              <h3 className="text-center">
                DECLARACIÓN JURAMENTADA DE RESIDENCIA
              </h3>

              <p className="text-justify">
                Señores, <br />
                {props.postulacion.linea_convocatoria?.toString().includes('SM -') ? (
                  <>
                    <strong>Convocatoria Estímulos a los Talentos y Liderazgos de las Mujeres</strong> <br />
                    Secretaría de las Mujeres <br />
                  </>
                ) : (
                  <>
                    <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                    Secretaría de Cultura Ciudadana <br />
                  </>
                )}
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación
              </p>
              <br />
              <p className="text-justify">
                Yo, <strong>{props.postulacion.nombre_representante}</strong>, identificado(a) con{" "}
                <strong> {datosDeclaracion?.tipo_documento || ""}</strong> número{" "}
                <strong> {props.postulacion.numero_documento_participante || ""}</strong>, manifiesto bajo{" "}
                gravedad de juramento que mi lugar de residencia es{" "}
                <strong>{datosDeclaracion?.ciudad || ""} </strong>
                y lo ha sido durante los
                últimos{" "}
                <strong>{datosDeclaracion?.anos_residencia || ""}</strong>{" "}
                años.
              </p>
              <br />
              <p><strong>Dirección: {datosDeclaracion?.direccion || ""}</strong></p>
              <p><strong>Ciudad: {datosDeclaracion?.ciudad || ""}</strong></p>
              {datosDeclaracion?.ciudad == "MEDELLÍN" && (
                <p><strong>Comuna: {datosDeclaracion?.comuna || ""}</strong></p>
              )}
              <p><strong>Correo electrónico: {datosDeclaracion?.correo || ""}</strong> </p>
              <p><strong>Teléfono: {datosDeclaracion?.telefono || ""}</strong> </p>

              <br />

              <p className="text-right">
                En constancia, se firma a los {datosDeclaracion?.fecha_firma}
                <img
                  src={fileName}
                  style={{
                    height: "50%",
                    width: "50%",
                    borderTop: "none",
                  }}
              alt=""
              />
              </p>
              <br /><br />
            </div>
          </div>
        </Modal>
      )}
      {openModalRelacion && (
        <Modal
          style={{ top: 20, zIndex: isExporting ? -999 : 3 }}
          wrapProps={{ style: isExporting ? { position: 'fixed', left: '-9999px' } : undefined }}
          mask={!isExporting}
          visible={openModalRelacion}
          width={900}
          footer={[
            <Button
              key="download"
              onClick={() => imprimirPdf(`Relacion_de_Participantes_${props.postulacion.radicado || ''}`, 'relacion')}
              className="button-blanco-radius"
            >
              Descargar PDF
            </Button>,
            <Button
              key="close"
              onClick={() => setOpenModalRelacion(false)}
              className="button-blanco-radius"
            >
              Cerrar
            </Button>
          ]}
          maskClosable={true}
          onCancel={() => setOpenModalRelacion(false)}
          maskStyle={{
            zIndex: 3,
            background: "rgb(12, 164, 93)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom_relacion" className="document-page">
              <h3 className="text-center">
                RELACIÓN DE PARTICIPANTES DE LA PROPUESTA
              </h3>
              <p className="text-justify">
                Señores, <br />
                <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                Secretaría de Cultura Ciudadana <br />
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación
              </p>
              <p className="text-justify">
                <strong>
                  Asunto: Relación de participantes para propuestas de personas jurídicas
                </strong>
              </p>
              <p className="text-justify">
                A continuación, relacionamos las personas que desarrollarán la propuesta {" "}
                <strong>{datosRelacion?.datos_empresa?.razon_social}</strong> presentada en la {" "}
                <strong>{props.postulacion.linea_convocatoria}</strong>.
              </p>
              <div>
                {datosRelacion?.participantes && Array.isArray(datosRelacion.participantes) && datosRelacion.participantes.length > 0 ? (
                  <div style={{ fontSize: '9px', marginTop: '20px' }}>
                    {datosRelacion.participantes.map((participante: any, index: number) => {
                      return <ParticipanteCard key={participante.numeroDocumento ?? String(index)} participante={participante} index={index} firmasParticipantes={firmasParticipantes} />;
                    })}
                  </div>
                ) : (
                  <p className="text-justify" style={{ fontSize: '12px' }}>
                    No hay participantes registrados.
                  </p>
                )}
              </div>
              <div>
                <p className="text-right">
                  En constancia, se firma en Medellín a los {datosRelacion.fecha_firma}.
                  <br />
                  <br />
                  <br />
                  {firmaParticipante ? (
                    <img
                      src={firmaParticipante}
                      alt="Firma del representante legal"
                      style={{
                        height: "50%",
                        width: "50%",
                        borderTop: "none",
                      }}
                    />
                  ) : (
                    <div style={{ height: "100px", width: "50%", border: "1px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", color: "#999" }}>
                      Sin firma
                    </div>
                  )}
                  <br />
                  <strong>
                    {datosRelacion?.participantes[0]?.nombresApellidos}
                  </strong>
                  <br />
                  Representante legal
                </p>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {openModalCartaConformacion && (
        <Modal
          style={{ top: 20, zIndex: isExporting ? -999 : 3 }}
          wrapProps={{ style: isExporting ? { position: 'fixed', left: '-9999px' } : undefined }}
          mask={!isExporting}
          visible={openModalCartaConformacion}
          width={900}
          footer={[
            <Button
              key="download"
              onClick={() => imprimirPdf(`Carta_de_Conformacion_de_Grupo_${props.postulacion.radicado || ''}`, 'carta')}
              className="button-blanco-radius"
            >
              Descargar PDF
            </Button>,
            <Button
              key="close"
              onClick={() => setOpenModalCartaConformacion(false)}
              className="button-blanco-radius"
            >
              Cerrar
            </Button>
          ]}
          maskClosable={true}
          onCancel={() => setOpenModalCartaConformacion(false)}
          maskStyle={{
            zIndex: 3,
            background: "rgb(12, 164, 93)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom_carta" className="document-page">
              <h3 className="text-center">
                CARTA DE CONFORMACIÓN DE GRUPO
              </h3>
              <p className="text-justify">
                Señores, <br />
                <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                Secretaría de Cultura Ciudadana <br />
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación
              </p>
              <p className="text-justify">
                Los suscritos abajo firmantes, manifestamos por medio de este documento, que conformamos el grupo {" "}
                <strong>
                  {datosCartaConformacion?.participantes[0]?.nombreGrupo}
                  {" "}
                </strong> y que hemos decidido participar en la línea {" "}
                <strong>{props.postulacion.linea_convocatoria}</strong> {" "}
                para lo cual afirmamos conocer las condiciones generales y específicas de participación.
              </p>
              <p className="text-justify">
                Para efectos del proceso de la convocatoria, designamos como representante del grupo a {" "}
                <strong> {datosCartaConformacion?.participantes[0]?.nombresApellidos} </strong> {" "}
                identificado(a) con{" "}
                <strong> {datosCartaConformacion?.participantes[0]?.tipoDocumento}</strong> número{" "}
                <strong> {datosCartaConformacion?.participantes[0]?.numeroDocumento}</strong>, quien está expresamente facultado(a) para firmar,{" "}
                presentar la propuesta, y en caso de resultar beneficiarios de un estímulo, firmar los
                documentos necesarios y tomar todas las decisiones que fueren necesarias.
              </p>
              <p className="text-justify">
                Además, manifestamos bajo gravedad de juramento que ninguno de los integrantes del  grupo relacionados a continuación, incluido el representante, está incurso en las limitantes  establecidas en la convocatoria.
              </p>
              <div>
                {datosCartaConformacion?.participantes && Array.isArray(datosCartaConformacion.participantes) && datosCartaConformacion.participantes.length > 0 ? (
                  <div style={{ fontSize: '9px', marginTop: '20px' }}>
                    {datosCartaConformacion.participantes.map((participante: any, index: number) => {
                      return <ParticipanteCard key={participante.numeroDocumento ?? String(index)} participante={participante} index={index} firmasParticipantes={firmasParticipantes} />;
                    })}
                  </div>
                ) : (
                  <p className="text-justify" style={{ fontSize: '12px' }}>
                    No hay participantes registrados.
                  </p>
                )}
              </div>
              <div>
                <p className="text-right">
                  En constancia, se firma en Medellín a los {datosCartaConformacion?.fecha_firma}.
                  <br />
                  <br />
                  <br />
                  {firmaParticipante ? (
                    <img
                      src={firmaParticipante}
                      alt="Firma del representante legal"
                      style={{
                        height: "50%",
                        width: "50%",
                        borderTop: "none",
                      }}
                    />
                  ) : (
                    <div style={{ height: "100px", width: "50%", border: "1px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", color: "#999" }}>
                      Sin firma
                    </div>
                  )}
                  <br />
                  <strong>
                    {datosCartaConformacion?.participantes[0]?.nombresApellidos}
                  </strong>
                  <br />
                  Representante del grupo
                </p>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {openModalDeclaracionGC && (
        <Modal
          style={{ top: 20, zIndex: isExporting ? -999 : 3 }}
          wrapProps={{ style: isExporting ? { position: 'fixed', left: '-9999px' } : undefined }}
          mask={!isExporting}
          visible={openModalDeclaracionGC}
          width={900}
          footer={[
            <Button
              key="download"
              onClick={() => imprimirPdf(`Declaracion_Residencia_GC_${props.postulacion.radicado || ''}`, 'declaracion_gc')}
              className="button-blanco-radius"
            >
              Descargar PDF
            </Button>,
            <Button
              key="close"
              onClick={() => setOpenModalDeclaracionGC(false)}
              className="button-blanco-radius"
            >
              Cerrar
            </Button>
          ]}
          maskClosable={true}
          onCancel={() => setOpenModalDeclaracionGC(false)}
          maskStyle={{
            zIndex: 3,
            background: "rgb(12, 164, 93)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom_declaracion_gc" className="document-page">
              <h3 className="text-center">
                DECLARACIÓN JURAMENTADA DE RESIDENCIA PARA GRUPOS CONFORMADOS
              </h3>
              <p className="text-justify">
                Señores, <br />
                <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                Secretaría de Cultura Ciudadana <br />
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación
              </p>
              <p className="text-justify">
                Los suscritos abajo firmantes, manifestamos por medio de este documento, que conformamos el grupo {" "}
                <strong>
                  {datosDeclaracionGC?.participantes[0]?.nombreGrupo}
                  {" "}
                </strong> y que hemos decidido participar en la línea {" "}
                <strong>{props.postulacion.linea_convocatoria}</strong> {" "}
                para lo cual afirmamos conocer las condiciones generales y específicas de participación.
              </p>
              <p className="text-justify">
                Para efectos del proceso de la convocatoria, designamos como representante del grupo a {" "}
                <strong> {datosDeclaracionGC?.participantes[0]?.nombresApellidos} </strong> {" "}
                identificado(a) con{" "}
                <strong> {datosDeclaracionGC?.participantes[0]?.tipoDocumento}</strong> número{" "}
                <strong> {datosDeclaracionGC?.participantes[0]?.numeroDocumento}</strong>, quien está expresamente facultado(a) para firmar,{" "}
                presentar la propuesta, y en caso de resultar beneficiarios de un estímulo, firmar los
                documentos necesarios y tomar todas las decisiones que fueren necesarias.
              </p>
              <p>
                También, manifestamos que ninguno de los integrantes del grupo está incurso en las limitantes establecidas en la convocatoria.
              </p>
              <p className="text-justify">
                Además, los abajo firmantes, manifestamos la bajo gravedad de juramento, que nuestros lugares de residencia son los que se relacionan a continuación:
              </p>
              <div>
                {datosDeclaracionGC?.participantes && Array.isArray(datosDeclaracionGC.participantes) && datosDeclaracionGC.participantes.length > 0 ? (
                  <div style={{ fontSize: '9px', marginTop: '20px' }}>
                    {datosDeclaracionGC.participantes.map((participante: any, index: number) => {
                      return <ParticipanteCard key={participante.numeroDocumento ?? String(index)} participante={participante} index={index} firmasParticipantes={firmasParticipantes} />;
                    })}
                  </div>
                ) : (
                  <p className="text-justify" style={{ fontSize: '12px' }}>
                    No hay participantes registrados.
                  </p>
                )}
              </div>
              <div>
                <p className="text-right">
                  En constancia, se firma en Medellín a los {datosDeclaracionGC?.fecha_firma}.
                  <br />
                  <br />
                  <br />
                  {firmaParticipante ? (
                    <img
                      src={firmaParticipante}
                      alt="Firma del representante legal"
                      style={{
                        height: "50%",
                        width: "50%",
                        borderTop: "none",
                      }}
                    />
                  ) : (
                    <div style={{ height: "100px", width: "50%", border: "1px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", color: "#999" }}>
                      Sin firma
                    </div>
                  )}
                  <br />
                  <strong>
                    {datosDeclaracionGC?.participantes[0]?.nombresApellidos}
                  </strong>
                  <br />
                  Representante del grupo
                </p>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
